import React, { useState } from 'react';
import { DataTable } from '../components/DataTable';
import { WizardForm } from '../components/WizardForm';
import { StatusBadge } from '../components/StatusBadge';
export function VesselManagement() {
  const [activeTab, setActiveTab] = useState<'list' | 'register'>('list');
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    vesselName: '',
    regNumber: '',
    regDate: '',
    issuingAuthority: '',
    blcNo: '',
    licenseIssueDate: '',
    licenseExpiryDate: '',
    vesselLength: '',
    vesselWidth: '',
    depthDraft: '',
    engineType: '',
    engineNumber: '',
    enginePower: '',
    fuelType: '',
    carryingCapacity: '',
    vesselType: '',
    operatingArea: '',
    ownerName: '',
    ownerNid: '',
    contactNumber: '',
    emailAddress: '',
    address: '',
    organization: '',
    village: '',
    union: '',
    upazila: '',
    district: '',
    range: '',
    route: '',
    blcAttachment: ''
  });
  const vessels = [{
    vesselName: 'MV Sundarban-1',
    regNumber: 'REG-2024-001',
    ownerName: 'Rahim Uddin',
    vesselType: 'Trawler',
    contactNumber: '01711223344',
    email: 'rahim@vessel.com',
    status: 'active' as const
  }, {
    vesselName: 'FV Padma-3',
    regNumber: 'REG-2024-002',
    ownerName: 'Karim Sheikh',
    vesselType: 'Boat',
    contactNumber: '01811334455',
    email: 'karim@vessel.com',
    status: 'active' as const
  }, {
    vesselName: 'BT Meghna-7',
    regNumber: 'REG-2024-003',
    ownerName: 'Abdul Hakim',
    vesselType: 'Ship',
    contactNumber: '01911445566',
    email: 'abdul@vessel.com',
    status: 'expired' as const
  }, {
    vesselName: 'LV Jamuna-2',
    regNumber: 'REG-2024-004',
    ownerName: 'Jamal Hossain',
    vesselType: 'Launch',
    contactNumber: '01611556677',
    email: 'jamal@vessel.com',
    status: 'active' as const
  }, {
    vesselName: 'FT Karnaphuli-5',
    regNumber: 'REG-2024-005',
    ownerName: 'Fatema Begum',
    vesselType: 'Trawler',
    contactNumber: '01511667788',
    email: 'fatema@vessel.com',
    status: 'suspended' as const
  }];
  const columns = [{
    key: 'vesselName',
    label: 'Vessel Name'
  }, {
    key: 'regNumber',
    label: 'Registration Number'
  }, {
    key: 'ownerName',
    label: 'Owner Name'
  }, {
    key: 'vesselType',
    label: 'Vessel Type'
  }, {
    key: 'contactNumber',
    label: 'Contact Number'
  }, {
    key: 'email',
    label: 'Email'
  }, {
    key: 'status',
    label: 'Status',
    render: (value: string) => <StatusBadge status={value as any} data-id="element-2223" />
  }];
  const filters = [{
    key: 'vesselType',
    label: 'Vessel Type',
    options: ['Boat', 'Launch', 'Ship', 'Trawler']
  }, {
    key: 'status',
    label: 'Status',
    options: ['Active', 'Expired', 'Suspended']
  }];
  const wizardSteps = [{
    title: 'Vessel Details',
    description: 'Enter vessel and technical information'
  }, {
    title: 'Owner & Location',
    description: 'Enter owner and operational details'
  }, {
    title: 'Documents',
    description: 'Upload required certificates'
  }, {
    title: 'Review & Submit',
    description: 'Review all information before submitting'
  }];
  return <div className="space-y-6" data-id="element-2224">
      <div data-id="element-2225">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-2226">Vessel Management</h1>
        <p className="text-sm text-gray-600 mt-1" data-id="element-2227">
          Manage boat registrations and licenses
        </p>
      </div>

      <div className="border-b border-gray-200" data-id="element-2228">
        <div className="flex gap-4" data-id="element-2229">
          <button onClick={() => setActiveTab('list')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'list' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-2230">
            Vessel Registry
          </button>
          <button onClick={() => setActiveTab('register')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'register' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-2231">
            Register Vessel
          </button>
        </div>
      </div>

      {activeTab === 'list' ? <DataTable columns={columns} data={vessels} filters={filters} onView={row => console.log('View', row)} onEdit={row => console.log('Edit', row)} onDelete={row => console.log('Delete', row)} searchPlaceholder="Search vessels..." data-id="element-2232" /> : <WizardForm steps={wizardSteps} currentStep={currentStep} onStepChange={setCurrentStep} onSubmit={() => {
      if (!formData.vesselName || !formData.regNumber) {
        alert('Please fill in all required fields.');
        return;
      }
      alert('Vessel registered successfully!');
      setCurrentStep(0);
      setActiveTab('list');
      setFormData({
        vesselName: '',
        regNumber: '',
        regDate: '',
        issuingAuthority: '',
        blcNo: '',
        licenseIssueDate: '',
        licenseExpiryDate: '',
        vesselLength: '',
        vesselWidth: '',
        depthDraft: '',
        engineType: '',
        engineNumber: '',
        enginePower: '',
        fuelType: '',
        carryingCapacity: '',
        vesselType: '',
        operatingArea: '',
        ownerName: '',
        ownerNid: '',
        contactNumber: '',
        emailAddress: '',
        address: '',
        organization: '',
        village: '',
        union: '',
        upazila: '',
        district: '',
        range: '',
        route: '',
        blcAttachment: ''
      });
    }} data-id="element-2233">
          {currentStep === 0 && <div className="space-y-4" data-id="element-2234">
              <div className="grid grid-cols-2 gap-4" data-id="element-2235">
                <div data-id="element-2236">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2237">
                    Vessel Name *
                  </label>
                  <input type="text" required value={formData.vesselName} onChange={e => setFormData({
              ...formData,
              vesselName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2238" />
                </div>
                <div data-id="element-2239">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2240">
                    Registration Number *
                  </label>
                  <input type="text" required value={formData.regNumber} onChange={e => setFormData({
              ...formData,
              regNumber: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2241" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-2242">
                <div data-id="element-2243">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2244">
                    Registration Date
                  </label>
                  <input type="date" value={formData.regDate} onChange={e => setFormData({
              ...formData,
              regDate: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2245" />
                </div>
                <div data-id="element-2246">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2247">
                    Issuing Authority
                  </label>
                  <input type="text" value={formData.issuingAuthority} onChange={e => setFormData({
              ...formData,
              issuingAuthority: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2248" />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-2249">
                <div data-id="element-2250">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2251">
                    BLC No.
                  </label>
                  <input type="text" value={formData.blcNo} onChange={e => setFormData({
              ...formData,
              blcNo: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2252" />
                </div>
                <div data-id="element-2253">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2254">
                    License Issue Date
                  </label>
                  <input type="date" value={formData.licenseIssueDate} onChange={e => setFormData({
              ...formData,
              licenseIssueDate: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2255" />
                </div>
                <div data-id="element-2256">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2257">
                    License Expiry Date
                  </label>
                  <input type="date" value={formData.licenseExpiryDate} onChange={e => setFormData({
              ...formData,
              licenseExpiryDate: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2258" />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-2259">
                <div data-id="element-2260">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2261">
                    Vessel Length
                  </label>
                  <input type="text" value={formData.vesselLength} onChange={e => setFormData({
              ...formData,
              vesselLength: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2262" />
                </div>
                <div data-id="element-2263">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2264">
                    Vessel Width
                  </label>
                  <input type="text" value={formData.vesselWidth} onChange={e => setFormData({
              ...formData,
              vesselWidth: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2265" />
                </div>
                <div data-id="element-2266">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2267">
                    Depth / Draft
                  </label>
                  <input type="text" value={formData.depthDraft} onChange={e => setFormData({
              ...formData,
              depthDraft: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2268" />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-2269">
                <div data-id="element-2270">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2271">
                    Engine Type
                  </label>
                  <input type="text" value={formData.engineType} onChange={e => setFormData({
              ...formData,
              engineType: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2272" />
                </div>
                <div data-id="element-2273">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2274">
                    Engine Number
                  </label>
                  <input type="text" value={formData.engineNumber} onChange={e => setFormData({
              ...formData,
              engineNumber: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2275" />
                </div>
                <div data-id="element-2276">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2277">
                    Engine Power (HP)
                  </label>
                  <input type="text" value={formData.enginePower} onChange={e => setFormData({
              ...formData,
              enginePower: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2278" />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-2279">
                <div data-id="element-2280">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2281">
                    Fuel Type
                  </label>
                  <select value={formData.fuelType} onChange={e => setFormData({
              ...formData,
              fuelType: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2282">
                    <option value="" data-id="element-2283">Select Fuel</option>
                    <option value="Diesel" data-id="element-2284">Diesel</option>
                    <option value="Petrol" data-id="element-2285">Petrol</option>
                    <option value="CNG" data-id="element-2286">CNG</option>
                    <option value="Manual" data-id="element-2287">Manual</option>
                  </select>
                </div>
                <div data-id="element-2288">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2289">
                    Carrying Capacity
                  </label>
                  <input type="text" value={formData.carryingCapacity} onChange={e => setFormData({
              ...formData,
              carryingCapacity: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2290" />
                </div>
                <div data-id="element-2291">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2292">
                    Vessel Type
                  </label>
                  <select value={formData.vesselType} onChange={e => setFormData({
              ...formData,
              vesselType: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2293">
                    <option value="" data-id="element-2294">Select Type</option>
                    <option value="Boat" data-id="element-2295">Boat</option>
                    <option value="Launch" data-id="element-2296">Launch</option>
                    <option value="Ship" data-id="element-2297">Ship</option>
                    <option value="Trawler" data-id="element-2298">Trawler</option>
                  </select>
                </div>
              </div>
              <div data-id="element-2299">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2300">
                  Operating Area
                </label>
                <input type="text" value={formData.operatingArea} onChange={e => setFormData({
            ...formData,
            operatingArea: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2301" />
              </div>
            </div>}

          {currentStep === 1 && <div className="space-y-4" data-id="element-2302">
              <div className="grid grid-cols-2 gap-4" data-id="element-2303">
                <div data-id="element-2304">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2305">
                    Owner Name *
                  </label>
                  <input type="text" required value={formData.ownerName} onChange={e => setFormData({
              ...formData,
              ownerName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2306" />
                </div>
                <div data-id="element-2307">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2308">
                    Owner NID / Passport No.
                  </label>
                  <input type="text" value={formData.ownerNid} onChange={e => setFormData({
              ...formData,
              ownerNid: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2309" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-2310">
                <div data-id="element-2311">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2312">
                    Contact Number
                  </label>
                  <input type="tel" value={formData.contactNumber} onChange={e => setFormData({
              ...formData,
              contactNumber: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2313" />
                </div>
                <div data-id="element-2314">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2315">
                    Email Address
                  </label>
                  <input type="email" value={formData.emailAddress} onChange={e => setFormData({
              ...formData,
              emailAddress: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2316" />
                </div>
              </div>
              <div data-id="element-2317">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2318">
                  Address
                </label>
                <textarea rows={2} value={formData.address} onChange={e => setFormData({
            ...formData,
            address: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2319" />
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-2320">
                <div data-id="element-2321">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2322">
                    Organization
                  </label>
                  <select value={formData.organization} onChange={e => setFormData({
              ...formData,
              organization: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2323">
                    <option value="" data-id="element-2324">Select Organization</option>
                    <option value="Sundarban Fisheries Ltd" data-id="element-2325">
                      Sundarban Fisheries Ltd
                    </option>
                    <option value="Bay of Bengal Trading Co." data-id="element-2326">
                      Bay of Bengal Trading Co.
                    </option>
                    <option value="Khulna Honey Producers" data-id="element-2327">
                      Khulna Honey Producers
                    </option>
                    <option value="Mongla Port Services" data-id="element-2328">
                      Mongla Port Services
                    </option>
                    <option value="Satkhira Wood Industries" data-id="element-2329">
                      Satkhira Wood Industries
                    </option>
                  </select>
                </div>
                <div data-id="element-2330">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2331">
                    Village
                  </label>
                  <select value={formData.village} onChange={e => setFormData({
              ...formData,
              village: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2332">
                    <option value="" data-id="element-2333">Select Village</option>
                    <option value="Munshiganj" data-id="element-2334">Munshiganj</option>
                    <option value="Gabura" data-id="element-2335">Gabura</option>
                    <option value="Shyamnagar" data-id="element-2336">Shyamnagar</option>
                    <option value="Koyra" data-id="element-2337">Koyra</option>
                    <option value="Dacope" data-id="element-2338">Dacope</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-2339">
                <div data-id="element-2340">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2341">
                    Union
                  </label>
                  <select value={formData.union} onChange={e => setFormData({
              ...formData,
              union: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2342">
                    <option value="" data-id="element-2343">Select Union</option>
                    <option value="Burigoalini" data-id="element-2344">Burigoalini</option>
                    <option value="Gabura" data-id="element-2345">Gabura</option>
                    <option value="Munshiganj" data-id="element-2346">Munshiganj</option>
                    <option value="Koyra" data-id="element-2347">Koyra</option>
                    <option value="Dacope" data-id="element-2348">Dacope</option>
                  </select>
                </div>
                <div data-id="element-2349">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2350">
                    Upazila
                  </label>
                  <select value={formData.upazila} onChange={e => setFormData({
              ...formData,
              upazila: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2351">
                    <option value="" data-id="element-2352">Select Upazila</option>
                    <option value="Shyamnagar" data-id="element-2353">Shyamnagar</option>
                    <option value="Koyra" data-id="element-2354">Koyra</option>
                    <option value="Dacope" data-id="element-2355">Dacope</option>
                    <option value="Mongla" data-id="element-2356">Mongla</option>
                    <option value="Sarankhola" data-id="element-2357">Sarankhola</option>
                  </select>
                </div>
                <div data-id="element-2358">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2359">
                    District
                  </label>
                  <select value={formData.district} onChange={e => setFormData({
              ...formData,
              district: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2360">
                    <option value="" data-id="element-2361">Select District</option>
                    <option value="Satkhira" data-id="element-2362">Satkhira</option>
                    <option value="Khulna" data-id="element-2363">Khulna</option>
                    <option value="Bagerhat" data-id="element-2364">Bagerhat</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-2365">
                <div data-id="element-2366">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2367">
                    Range
                  </label>
                  <select value={formData.range} onChange={e => setFormData({
              ...formData,
              range: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2368">
                    <option value="" data-id="element-2369">Select Range</option>
                    <option value="Satkhira" data-id="element-2370">Satkhira</option>
                    <option value="Khulna" data-id="element-2371">Khulna</option>
                    <option value="Chandpai" data-id="element-2372">Chandpai</option>
                    <option value="Sarankhola" data-id="element-2373">Sarankhola</option>
                  </select>
                </div>
                <div data-id="element-2374">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2375">
                    Route
                  </label>
                  <input type="text" value={formData.route} onChange={e => setFormData({
              ...formData,
              route: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2376" />
                </div>
              </div>
            </div>}

          {currentStep === 2 && <div className="space-y-4" data-id="element-2377">
              <div data-id="element-2378">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2379">
                  Boat License Certificate (BLC) Attachment
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2380" />
                <p className="text-xs text-gray-500 mt-1" data-id="element-2381">
                  Upload PDF or Image file
                </p>
              </div>
            </div>}

          {currentStep === 3 && <div className="space-y-6" data-id="element-2382">
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-2383">
                <div className="flex items-center justify-between mb-3" data-id="element-2384">
                  <h4 className="font-semibold text-gray-900" data-id="element-2385">
                    Vessel Details
                  </h4>
                  <button onClick={() => setCurrentStep(0)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-2386">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-2387">
                  <div data-id="element-2388">
                    <span className="text-gray-600" data-id="element-2389">Name:</span>{' '}
                    <span className="font-medium" data-id="element-2390">
                      {formData.vesselName || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-2391">
                    <span className="text-gray-600" data-id="element-2392">Reg No:</span>{' '}
                    <span className="font-medium" data-id="element-2393">
                      {formData.regNumber || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-2394">
                    <span className="text-gray-600" data-id="element-2395">Type:</span>{' '}
                    <span className="font-medium" data-id="element-2396">
                      {formData.vesselType || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-2397">
                <div className="flex items-center justify-between mb-3" data-id="element-2398">
                  <h4 className="font-semibold text-gray-900" data-id="element-2399">
                    Owner & Location
                  </h4>
                  <button onClick={() => setCurrentStep(1)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-2400">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-2401">
                  <div data-id="element-2402">
                    <span className="text-gray-600" data-id="element-2403">Owner Name:</span>{' '}
                    <span className="font-medium" data-id="element-2404">
                      {formData.ownerName || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-2405">
                    <span className="text-gray-600" data-id="element-2406">Contact:</span>{' '}
                    <span className="font-medium" data-id="element-2407">
                      {formData.contactNumber || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-2408">
                    <span className="text-gray-600" data-id="element-2409">Organization:</span>{' '}
                    <span className="font-medium" data-id="element-2410">
                      {formData.organization || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>
            </div>}
        </WizardForm>}
    </div>;
}